import usePriceUnit from '@hooks/item/usePriceUnit';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import OrderSheetLayout from '../common/OrderSheetLayout';
import PrepaidCardRow from './components/PrepaidCardRow';
import PrepaidCardRowSkeletons from './components/PrepaidCardRowSkeletons';
import useOrderPrepaidCards from './hooks/useOrderPrepaidCards';

declare module '@stackflow/config' {
    interface Register {
        OrderPrepaidCardBottomSheet: {};
    }
}

/** 결제에 사용할 선불카드 선택 */
const OrderPrepaidCardBottomSheet: ActivityComponentType<'OrderPrepaidCardBottomSheet'> = () => {
    const { t } = useTranslation('order');
    const priceUnit = usePriceUnit();
    const {
        cards, selectedCardId, draftAmount, applyDisabled,
        togglePrepaidCard, handleApply, handleClose,
        isFetching,
    } = useOrderPrepaidCards();

    return (
        <BottomSheet>
            <OrderSheetLayout title={t('prepaidSheet.title')}
                isEmpty={cards?.length === 0}
                emptyText={t('prepaidSheet.empty')}
                closeLabel={t('prepaidSheet.close')}
                onClose={handleClose}
                applyLabel={t('prepaidSheet.apply')}
                onApply={handleApply}
                applyDisabled={applyDisabled}>
                {cards?.map((card) => (
                    <PrepaidCardRow key={card.id}
                        card={card}
                        isSelected={selectedCardId === card.id}
                        onToggle={() => togglePrepaidCard(card.id)} />
                ))}
                {isFetching && (
                    <PrepaidCardRowSkeletons/>
                )}
            </OrderSheetLayout>
        </BottomSheet>
    );
};

export default OrderPrepaidCardBottomSheet;
